<template>
	<div>
		<a-modal :title="$t('addClass.addCourse')" :width="650" :visible="visible" @cancel="handleCancel" :closable="false"
			:footer="null">
			<div class="flex end cl-theme text-underline clickAct" @click="referencePriceVisible = true">
				{{$t('addClass.referencePrice')}}
			</div>
			<div class="cl-black">
				{{$t('addClass.type')}}
			</div>
			<select class="form-select ft16 mt-2" aria-label="Default select example" v-model="courseClassifyId"
			@change="getCourse">
				<option :value="0">{{$t('addClass.pleaseSelect')}}</option>
				<option :value="item.id" v-for="(item,index) in classifyList" >{{item.name}}</option>
			</select>
			<div class="cl-black mt-3">
				{{$t('addClass.courseName')}}
			</div>
			<select class="form-select ft16 mt-2" v-model="courseInfo.course_id">
				<option :value="0">{{$t('addClass.pleaseSelect')}}</option>
				<option :value="item.id" v-for="(item,index) in courseList" >{{item.name}}</option>
			</select>
			<div class="mt-4">
				<div class="flex alcenter cl-black ftw600">
					<div class="becomeTeacher-wid-25">
						{{$t('addClass.classNumber')}}
					</div>
					<div class="becomeTeacher-wid-25">
						{{$t('addClass.discount')}}
					</div>
					<div class="becomeTeacher-wid-25">
						{{$t('addClass.teacherEarningsPerClass')}}
					</div>
					<div class="becomeTeacher-wid-25">
						{{$t('addClass.displayPricePerClass')}}
					</div>
				</div>
				<div class="cl-black text-underline"> 
					{{$t('common.experienceClass')}}
				</div>
				<div class="flex alcenter mt-3">
					<div class="becomeTeacher-wid-25">
						<div class="form-check">
							<label class="form-check-label flex" for="flexCheckDefault">
								1
							</label>
						</div>
					</div>
					<div class="becomeTeacher-wid-25">
						<div class=" br4 flex p-2 alcenter wid-fit">
							<div class="becomeTeacher-wid-25">
								{{$t('addClass.noDiscount')}}
							</div>
						</div>
					</div>
					<div class="becomeTeacher-wid-25">
						{{getCurrency()}}{{((classMoney/3)*(1 - Number(form.teacher_level.extraction_ratio)/100)).toFixed(2)}}
					</div>
					<div class="becomeTeacher-wid-25">
						{{getCurrency()}}{{(classMoney/3).toFixed(2)}}
					</div>
				</div>
				<div class="cl-black text-underline">
					{{$t('teacherVue.formalClasses')}}
				</div>
				<div class="flex alcenter mt-3">
					<div class="becomeTeacher-wid-25">
						1
					</div>
					<div class="becomeTeacher-wid-25">
						{{$t('addClass.noDiscount')}}
					</div>
					<div class="becomeTeacher-wid-25">
						{{getCurrency()}}{{teacherClassMoney}}
					</div>
					<div class="becomeTeacher-wid-25">
						<div class="border-gray br4 flex p-2 alcenter wid-fit">
							{{getCurrency()}} <input type="text" v-model="classMoney"
							style="flex: 1;border: none !important;width: 50px;" @input="getClassMoney">
						</div>
					</div>
				</div>
				
				<div class="flex alcenter mt-3" v-for="(item,index) in classList">
					<div class="becomeTeacher-wid-25">
						<div class="form-check">
							<input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
							 :checked="item.selected" @click="item.selected = !item.selected" >
							<label class="form-check-label flex" for="flexCheckDefault">
								{{item.num}}
								<div class="ft12 ml2 br4 px-1" style="border: 1px solid #F24C10;color: #F24C10;" v-if="index!=2">
									{{$t('addClass.popular')}}
								</div>
							</label>
						</div>
					</div>
					<div class="becomeTeacher-wid-25">
						<div class="border-gray br4 flex p-2 alcenter wid-fit">
							<input type="number" :placeholder="item.pl_discount" v-model="item.discount" @input="getClassMoney()"
								style="border: none !important;width: 100px !important;" min="0" :max="item.max">
						</div>
					</div>
					<div class="becomeTeacher-wid-25">
						{{getCurrency()}}{{item.money}}
					</div>
					<div class="becomeTeacher-wid-25">
						{{getCurrency()}}{{item.showMoney}}
					</div>
				</div>
				<div class="ft14 mt-4">
					{{$t('addClass.referenceMarketValue',{currency:getCurrency()})}}
					<!-- // 参考市值:最少{{getCurrency()}}{{convertCurrency(80)}}堂，每堂为50分鐘 -->
				</div>
				<div class="flex justify-content-center mt-5">
					<button type="button" class="btn btn-outline-gray px-3" @click="handleCancel">{{$t('common.cancel')}}</button>
					<button type="button" class="btn btn-theme ml16 px-3" @click="agencyCourse" > {{$t('addClass.save')}}</button>
				</div>
			</div>
			
			
			<a-modal :title="null" :width="650" :visible="referencePriceVisible" @cancel="referencePriceVisible = false" :closable="false"
				:footer="null">
				<div class=" flex center ftr-1-25">
					{{$t('addClass.referencePrice1')}}
				</div>
				<div class="flex center">
					{{$t('addClass.referencePrice2')}}
				</div>
				<div class="mt-4">
					<a-table :columns="columnsClass" rowKey="referencePrice3"  :pagination="false"
						:data-source="datasClass" >
					</a-table>
				</div>
				<div class="mt-3">
					{{$t('addClass.referencePrice13')}}
				</div>
				<div class="flex center mt-4">
					<div class="btn btn-theme clickAct" @click="referencePriceVisible = false">
						{{$t('viewCommission.gotIt')}}
					</div>
				</div>
			</a-modal>
			
			
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			typeId:{
				type:Number,
				default:0
			},
			course_id:{
				type:Number,
				default:0
			},
			list:{
				type:Array,
				default:[]
			},
			money:{
				type:Number,
				default:0
			},
			tCMoney:{
				type:Number,
				default:0
			},
			form:{
				type:Object,
				default:{}
			}
		},
		
		data() {
			return {
				classifyList:[],//课程分类
				courseClassifyId:0,//课程分类ID
				courseList:[],
				courseInfo:{
					course_id:0,
					teacherCourse:[]
				},
				classMoney:0,//一堂课的钱
				teacherClassMoney:0,//老师一堂课所得
				classList:[
					{
						num:5,
						discount:'',
						pl_discount:'0-9%',
						money:'',
						showMoney:'',
						selected:false,
						max:'9'
					},
					{
						num:10,
						discount:'',
						pl_discount:'0-19%',
						money:'',
						showMoney:'',
						selected:false,
						max:'19'
					},
					{
						num:20,
						discount:'',
						pl_discount:'0-29%',
						money:'',
						showMoney:'',
						selected:false,
						max:'29'
					}
				],//添加课程填写数据列表
				
				referencePriceVisible:false,
				columnsClass:[
					{
						title: this.$t('addClass.referencePrice3'),
						dataIndex: 'referencePrice3',
					},
					{
						title: this.$t('addClass.referencePrice4'),
						dataIndex: 'referencePrice4',
					},
					{
						title: this.$t('addClass.referencePrice5'),
						dataIndex: 'referencePrice5',
					},
					{
						title: this.$t('addClass.referencePrice6'),
						dataIndex: 'referencePrice6',
					},
					{
						title: this.$t('addClass.referencePrice7'),
						dataIndex: 'referencePrice7',
					}
				],
				datasClass:[
					{
						referencePrice3:this.$t('addClass.referencePrice8'),
						referencePrice4:'HK$140+',
						referencePrice5:'HK$200+',
						referencePrice6:'HK$250+',
						referencePrice7:'HK$300+'
					},
					{
						referencePrice3:this.$t('addClass.referencePrice9'),
						referencePrice4:'HK$160+',
						referencePrice5:'HK$230+',
						referencePrice6:'HK$270+',
						referencePrice7:'HK$350+'
					},
					{
						referencePrice3:this.$t('addClass.referencePrice10'),
						referencePrice4:'HK$180+',
						referencePrice5:'HK$250+',
						referencePrice6:'HK$300+',
						referencePrice7:'HK$400+'
					},
					{
						referencePrice3:this.$t('addClass.referencePrice11'),
						referencePrice4:'HK$200+',
						referencePrice5:'HK$280+',
						referencePrice6:'HK$350+',
						referencePrice7:'HK$450+'
					},
					{
						referencePrice3:this.$t('addClass.referencePrice12'),
						referencePrice4:'HK$300+',
						referencePrice5:'HK$400+',
						referencePrice6:'HK$450+',
						referencePrice7:'HK$600+'
					}
				]
			}
		},
		watch:{
			course_id(newValue){
				this.getCourse(true)
				this.courseInfo.course_id = newValue
				console.log('course_id: ', this.courseInfo.course_id);
			},
			list(newValue){
				this.classList = newValue
				console.log("--------------this.classList",this.classList);
			}
		},
		created() {
			this.getClassifyList();
			this.course_id?this.courseInfo.course_id = this.course_id:''
			this.list?this.classList = this.list:''
			this.typeId?this.courseClassifyId = this.typeId:''
			this.money?this.classMoney = this.money:''
			this.tCMoney?this.teacherClassMoney = this.tCMoney:''
			this.getClassMoney()
			this.course_id?this.getCourse(true):this.getCourse()
		},
		methods: {
			handleCancel() {
				this.$emit('cancel')
			},
			// 课程添加
			agencyCourse(){
				let arr = []
				arr.push({
					price:this.classMoney,
					quantity:1,
					discount:0,
					once_price:this.classMoney,
					is_experience:2
				})
				this.classList.forEach((item,index)=>{
					if(item.selected){
						arr.push({
							price:item.showMoney*item.num,
							quantity:item.num,
							discount:item.discount,
							once_price:item.showMoney,
							is_experience:2
						})
					}
				})
				arr.unshift({
					price:((this.classMoney/3)).toFixed(2),
					quantity:1,
					discount:0,
					once_price:((this.classMoney/3)).toFixed(2),
					is_experience:1
				})
				this.$http.api('teacher/teacher/agencyCourse',{
					course_id:this.courseInfo.course_id,
					teacherCourse:arr
				}).then(res=>{
					this.$message.success(this.$t('addClass.saveSuccess'))
					this.handleCancel()
				})
			},
			// 计算不同堂数的价钱
			getClassMoney(){
				let num = Number(this.form.teacher_level.extraction_ratio)/100 //平台抽成比例
				this.teacherClassMoney = this.classMoney-(this.classMoney * num) //老师一堂课收到的钱
				this.classList.forEach((item,index)=>{
					if(item.discount>item.max){
						item.discount = item.max
					}
					let disNum = 0
					item.discount !==''?disNum = Number(item.discount)/100:''
					item.showMoney = this.classMoney - (this.classMoney*disNum)
					item.money = this.teacherClassMoney - (this.teacherClassMoney*disNum)
					// console.log(item);
				})
			},
			// 课程分类
			async getClassifyList(teacherCourse){
				await this.$http.api('course/classifyList',{
					includeCourse:1,
					teacherCourse:teacherCourse?this.form.id:''
				}).then(res=>{
					if(teacherCourse){
						
						this.formTeacherC=res.list
						this.formTeacherTypeId = res.list[0].id
						this.formTeacherItem = res.list[0].course
					}else{
						this.classifyList = res.list
					}
				})
				
			},
			// 根据课程分类ID获取课程列表
			getCourse(edit){
				this.$http.api('course/courseList',{
					courseClassifyId:this.courseClassifyId
				}).then(res=>{
					this.courseList = res.list
					edit?'':this.courseInfo.course_id = 0
				})
			},
		}
	}
</script>

<style>
	.ant-table-thead > tr > th{
		background-color: #52C4C9 !important;
		color: #fff;
	}
	.ant-modal-header{
		border: none;
		text-align: center;
		padding-top: 16px;
	}
	.ant-modal-title{
		margin-top: 16px;
		font-size: 1.25rem !important;
		font-weight: 600 !important;
	}
	input:focus {
		outline: none;
	}
	
	.becomeTeacher-wid {
		width: 630px;
	}
	
	.becomeTeacher-wid-25 {
		width: 25%;
	}
	
	.becomeTeacher-hei {
		height: 70px;
	}
	
	.as-reservation-time {
		background-color: rgb(242, 242, 242);
		padding: 12px;
	}
	
	.as-reservation-time-item-del {
		position: absolute;
		top: 7px;
		right: 8px;
		cursor: pointer;
	}
	
	.as-reservation-time-item {
		position: relative;
		background-color: #ffffff;
		border-radius: 4px;
		padding: 8px;
	}
	
	.as-show-list-item {
		border: 1px solid #ebedf5;
		width: 54px;
		text-align: center;
		margin-bottom: 6px;
		margin-right: 6px;
		padding: 6px 0;
		border-radius: 4px;
		background-color: #fff;
	}
	
	@media (max-width:575.98px) {
		.becomeTeacher-wid {
			width: 100%;
		}
	}
	
	.video-item {
		margin-right: 20px;
	}
</style>